export default __webpack_public_path__ + "static/media/animation_audio_light.5952c1c5.gif";